<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" LOG>
          <v-card class="px-3" :loading="loading">
            <v-card-title :class="`${arabic?'arFont':'enFont'}`">
              LOG
              <v-btn color="success" x-small text @click="load_log()">reload</v-btn>
            </v-card-title>
            <v-card-text>
              <v-row class="pa-0 mb-2 px-2 align-start py-1 text-center">
                <v-col cols="6" :class="`${arabic?'arFont':'enFont'}`">
                  <v-row class="pa-0 mb-2 elevation-2 px-2 align-center py-1 text-center"  v-for="(convo, c) in last" :key="'convo-'+c">
                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                      {{convo.number}}
                      <v-chip x-small>{{convo.country}}</v-chip>
                      <v-chip x-small>{{convo.program}}</v-chip>
                      <v-btn color="success" text x-small @click="getLastMessage(convo)">get</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" :class="`${arabic?'arFont':'enFont'}`">
                  <v-row class="pa-0 mb-2 elevation-2 px-2 align-center py-3 text-center"  v-for="(msg, m) in msgs" :key="'msg-'+m">
                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} grey lighten-4`">
                      {{msg.body}}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};
import { storageRef, firebase, db, auth, store } from '@/fb';


export default {
  components: { Search, Paging, multiDialog },
  data() {
    return {
      loading:false,
      dialog:false,
      
      last:[],
      msgs:[],
    }
  },
  
  methods: {
    getFormat(d){
      return format(d)
    },
    
    async getLastMessage(convo){
      return new Promise(async (res, rej) =>{
        this.loading = true
        console.log(convo)
        let msgs = await store.collection("waconversations").doc(convo.key).collection('messages').get().then(x => x.docs.map(y => {
          return {
            ...y.data(),
            key: y.id
          }
        }));
        console.log(msgs)
        this.msgs = msgs.reverse()
        this.loading = false
        res(true)
      })
    },
    async load_log(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await store.collection("waconversations")
        .orderBy('last_message', 'desc')
        .limit(20).get().then(x => x.docs.map(y => {
          return {
            ...y.data(),
            key: y.id
          }
        }));
        console.log(a)
        this.last = a
        this.loading = false
        res(true)
      })
    },
    async init(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.load_log()
        res(true)
        this.loading = false
      })
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    await this.init()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>